module.exports = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"\">\r\n<path d=\"M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z\" fill=\"#DC0000\"></path>\r\n<path d=\"M17.6127 7.3335L18.5555 8.27631L10.2642 16.5677L5.33331 11.6365L6.22267 10.7471L10.2109 14.7353L17.6127 7.3335Z\" fill=\"white\"></path>\r\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/vaccine.svg
// module id = 426
// module chunks = 0